import { StepCard } from "../components/StepByStep"
import register from "../../../assets/img/stepByStep/register.svg"
import magnifyingGlass from "../../../assets/img/stepByStep/magnifyingGlass.svg"
import seed from "../../../assets/img/stepByStep/seed.svg"

export const StepByStep = () => {
    return (
        <div className="mx-auto w-[90%]">
            <StepCard
                key={1}
                number='1.'
                text="Obtén acceso a oportunidades únicas de primera mano y herramientas para aprender acerca de inversiones"
                title="Regístrate en Lokl"
                src={register}
                color='bg-[#DFDFFF]'
                link="/register"
            />
            <StepCard
                key={2}
                number='2.'
                text="Conoce cada proyecto, simula tu inversión y modela tu suscripción para pagos por cuotas y sin recargos."
                title="Explora proyectos"
                src={magnifyingGlass}
                color='bg-[#B1FFE0]'
                invested
                link='/nido'
            />
            <StepCard
                key={3}
                number='3.'
                text="Obtén altas rentabilidades y disfruta de sus beneficios único que tenemos para todos los inversionistas."
                title="Crece tu portafolio"
                src={seed}
                color='bg-[#D9D9D9]'
                link='/blog/lokl-cambiando-panorama-inversiones-inmobiliarias'
            />
        </div>
    )
}
